import React from 'react';
import Career from '../components/Career';

const CareerPage = () => {
  return <Career />;
};

export default CareerPage;